export const oldVyTypography = {
  fontFamily: 'Inter, sans-serif',
  h1: {
    marginBottom: '-4px',
  },
  h2: {
    marginBottom: '-4px',
  },
  h3: {
    marginBottom: '-4px',
  },
  h4: {
    marginBottom: '-4px',
  },
  h5: {
    marginBottom: '-4px',
  },
  h6: {
    marginBottom: '-4px',
  },
};
